<template>
  <v-container>
    <v-row>
      <v-col cols="9">
        <v-skeleton-loader
          :loading="collectionPointLoading"
          :types="skeleton"
          type="article"
          class="mb-6"
          height="266"
        >
          <CollectionPointHeaderCard
            title="Nahlášení odečtu"
            detailType="reportReading"
            :data="collectionPoint"
          />
        </v-skeleton-loader>

        <v-skeleton-loader
          :loading="collectionPointLoading"
          :types="skeleton"
          type="article"
          class="mb-6"
          height="266"
        >
          <v-card class="elevation-12">
            <v-card-text class="px-9">
              <ValidationObserver
                ref="reportReadingForm"
                v-slot="{ passes }"
              >
                <v-form rel="reportReadingForm" @submit.prevent="passes(save)">
                  <v-row v-if="!canEdit">
                    <v-col>
                      <v-alert type="info">
                        Odečet lze vkládát pouze pro EAN s typem měření C v kategorii 4.
                      </v-alert>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-row>
                        <v-col cols="12" class="py-0">
                          <VAutocompleteWithValidation
                            rules="required"
                            outlined
                            dense
                            label="Typ odečtu"
                            v-model="reportReading.type"
                            :items="reportReadingTypes"
                            item-text="localizedText"
                            item-value="name"
                            :disabled="!canEdit"
                            :readonly="collectionPoint.allowedInstallationAction.name === 'READING'"
                          />
                        </v-col>
                      </v-row>

                      <v-row>
                        <VDatePickerWithTextField
                          :rules="{
                            'dateFormat': true,
                            'required': true,
                            'before': maxForReadingDateFormatted,
                          }"
                          :disabled="reportReading.type === 'EXTRAORDINARY_INVOICING' || !canEdit"
                          v-model="reportReading.date"
                          label="Datum odečtu"
                          :max="maxForReadingDateFormatted"
                          :min="minForReadingDateFormatted"
                          :allowed-dates="allowedDates"
                          menuAttach=".detail-datepicker--reading"
                          cols="4"
                          colClass="py-0 detail-datepicker detail-datepicker--reading"
                        />
                        <v-col
                          class="py-2"
                          v-if="collectionPoint.lastReadingAt"
                        >
                          Poslední datum odečtu:
                          {{ formatDate(collectionPoint.lastReadingAt) }}
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="4" class="py-0">
                          <VTextFieldWithValidation
                            v-mask="'#######'"
                            rules="required"
                            v-model="reportReading.highTariff"
                            outlined
                            dense
                            label="Vysoký tarif"
                            :disabled="!canEdit"
                          />
                        </v-col>

                        <v-col class="py-2">
                          Poslední stav elektroměru (VT):
                          {{
                            collectionPoint.lastReadingHighTariff
                              ? collectionPoint.lastReadingHighTariff
                              : '0'
                          }}
                          kWh
                        </v-col>
                      </v-row>

                      <v-row v-if="!!!collectionPoint.distributionRateSingleTariff">
                        <v-col cols="4" class="py-0">
                          <VTextFieldWithValidation
                            v-mask="'#######'"
                            :rules="{
                              required: !!!collectionPoint.distributionRateSingleTariff
                            }"
                            v-model="reportReading.lowTariff"
                            outlined
                            dense
                            label="Nízký tarif"
                            :disabled="!canEdit"
                          />
                        </v-col>

                        <v-col class="py-2">
                          Poslední stav elektroměru (NT):
                          {{
                            collectionPoint.lastReadingLowTariff
                              ? collectionPoint.lastReadingLowTariff
                              : '0'
                          }}
                          kWh
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col>
                          <v-btn
                            depressed
                            type="submit"
                            height="40px"
                            min-width="125px"
                            color="primary"
                            :loading="loading"
                            :disabled="!canEdit"
                          >
                            Odeslat
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-form>
              </ValidationObserver>
            </v-card-text>
          </v-card>
        </v-skeleton-loader>
      </v-col>

      <CollectionPointRightSideCards
        :collectionPoint="collectionPoint"
        @searchInstallation="searchInstallation"
        @installationLoading="collectionPointLoading = $event"
        :eanErrorMessage="eanErrorMessage"
        :collectionPointLoading="collectionPointLoading"
      />
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import CollectionPointHeaderCard from '@/components/CollectionPointHeaderCard.vue';
import { installationMixin } from '@/components/mixins/installationMixin';
import CollectionPointRightSideCards from '@/components/utils/CollectionPointRightSideCards.vue';
import { onInstallationSaveSuccess } from '@/components/mixins/saveSuccess';
import VDatePickerWithTextField from '@/components/VDatePickerWithTextField.vue';

export default {
  name: 'ReportReadingDetail',
  mixins: [installationMixin, onInstallationSaveSuccess],
  components: {
    CollectionPointHeaderCard,
    CollectionPointRightSideCards,
    VDatePickerWithTextField,
  },
  data() {
    return {
      reportReadingTypes: [],
      reportReading: {
        type: null,
        date: null,
        highTariff: null,
        lowTariff: null,
      },
      loading: false,
      availableDatesForExtraordinaryInvoicingAllYear: [],
    };
  },
  watch: {
    'reportReading.type': {
      handler() {
        if (this.reportReading.type === 'EXTRAORDINARY_INVOICING') {
          if (this.$dayjs().format('YYYY-MM-DD')
            === this.$dayjs().set('month', 11).set('date', 31).format('YYYY-MM-DD')) {
            this.reportReading.date = this.$dayjs().set('month', 11).set('date', 31)
              .format('YYYY-MM-DD');
          } else {
            this.reportReading.date = this.$dayjs().subtract(1, 'year').set('month', 11).set('date', 31)
              .format('YYYY-MM-DD');
          }
        }
      },
    },
    $route: {
      handler() {
        this.reportReading = {
          type: null,
          date: null,
          highTariff: null,
          lowTariff: null,
        };
      },
    },
    'collectionPoint.allowedInstallationAction': {
      handler() {
        if (this.collectionPoint.allowedInstallationAction.name === 'READING'
          && this.typesHasEndOfDeliveryType()) {
          this.reportReading.type = this.reportReadingTypes.find((type) => type.name === 'END_OF_DELIVERY').name;
        }
      },
    },
  },
  methods: {
    ...mapActions({
      getIndividualReadingTypes: 'requests/getIndividualReadingTypes',
      sendIndividualReadingRequest: 'requests/sendIndividualReadingRequest',
    }),
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    },
    save() {
      this.loading = true;
      const requestData = {
        ean: this.collectionPoint.ean,
        reportReading: this.reportReading,
      };
      this.sendIndividualReadingRequest(requestData).then((response) => {
        this.onInstallationSaveSuccess(response);
      }).finally(() => {
        this.loading = false;
      });
    },
    loadIndividualReadingTypes() {
      return new Promise((resolve) => {
        this.getIndividualReadingTypes().then((response) => {
          this.reportReadingTypes = response.data;
        }).finally(() => {
          resolve();
        });
      });
    },
    typesHasEndOfDeliveryType() {
      return this.reportReadingTypes.some((type) => {
        if (type.name === 'END_OF_DELIVERY') {
          return true;
        }
        return false;
      });
    },
    getAllowedDatesForExtraordinaryInvoicingAllYear() {
      const lastMonth = this.$dayjs().add(-1, 'month').format('YYYY-MM-DD');
      this.$http.get(`/requests/enumeration/calendar/working-days?dateSince=${lastMonth}&months=2`)
        .then((response) => {
          const lastDayOfLastYear = this.$dayjs().add(-1, 'year').endOf('year').format('YYYY-MM-DD');
          const workDatesBeforeActualDate = response.data
            .filter((item) => new Date(item) < new Date());
          const actualDateString = this.$dayjs().format('YYYY-MM-DD');
          const minIndex = workDatesBeforeActualDate.includes(actualDateString) ? 6 : 5;
          const minWorkDate = workDatesBeforeActualDate.length < minIndex
            ? workDatesBeforeActualDate[0]
            : workDatesBeforeActualDate[workDatesBeforeActualDate.length - minIndex];
          const allowedDates = [];
          allowedDates.push(minWorkDate);
          let date = minWorkDate;
          while (date !== actualDateString) {
            date = this.$dayjs(new Date(date)).add(1, 'day').format('YYYY-MM-DD');
            // not add last day of last year because it is for reading type EXTRAORDINARY_INVOICING
            if (date !== lastDayOfLastYear) {
              allowedDates.push(date);
            }
          }
          this.availableDatesForExtraordinaryInvoicingAllYear = allowedDates;
        });
    },
  },
  computed: {
    maxForReadingDateFormatted() {
      return new Date().toISOString();
    },
    canEdit() {
      return this.collectionPoint && this.collectionPoint.measureType === 'C' && this.collectionPoint.measureCategory === '4';
    },
    minForReadingDateFormatted() {
      if (this.reportReading.type === 'EXTRAORDINARY_INVOICING_ALL_YEAR') {
        return new Date(this.availableDatesForExtraordinaryInvoicingAllYear[0]).toISOString();
      }
      return null;
    },
    allowedDates() {
      if (this.reportReading.type === 'EXTRAORDINARY_INVOICING_ALL_YEAR') {
        return (val) => this.availableDatesForExtraordinaryInvoicingAllYear.includes(val);
      }
      return null;
    },
  },
  created() {
    this.loadInstallation().then((response) => {
      this.loadIndividualReadingTypes().then(() => {
        if (response.data.allowedInstallationAction.name === 'NONE_MANUFACTURING_INSTALLATION'
          || response.data.allowedInstallationAction.name === 'NONE_DISTRIBUTION_ONLY_INSTALLATION') {
          this.$router.push({
            name: 'collectionPoint',
            params: {
              ean: this.$route.params.ean,
              eanErrorMessage: response.data.allowedInstallationAction.localizedText,
            },
          });
        } else if (response.data.allowedInstallationAction.name === 'READING'
          && this.typesHasEndOfDeliveryType()) {
          this.reportReading.type = this.reportReadingTypes.find((type) => type.name === 'END_OF_DELIVERY').name;
        }
        this.redirectByVoltageLevel(response.data, 'VN');
      });
    });
    this.getAllowedDatesForExtraordinaryInvoicingAllYear();
  },
};
</script>
